var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" " + _vm._s(_vm.$t("parametro.title")))
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    filters: _vm.filters,
                    graphql: _vm.graphql
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c(
                            "td",
                            { staticClass: "nowrap" },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { slot: "activator", icon: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.editItem(
                                            parseInt(items.item.id),
                                            "parametro",
                                            _vm.dataGraphql
                                          )
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("edit")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Editar registro")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { slot: "activator", icon: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.deleteItem(
                                            parseInt(items.item.id),
                                            "parametro"
                                          )
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "red" } },
                                        [_vm._v("delete")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Eliminar registro")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(items.item.nombre))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("v-tooltip", { attrs: { bottom: "" } }, [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "activator" },
                                    slot: "activator"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filter.characters(
                                          items.item.valor,
                                          50
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(items.item.valor))])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(items.item.label))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(items.item.descripcion))])
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                color: "primary",
                                dark: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.openModal()
                                }
                              },
                              slot: "activator"
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(" " + _vm._s(_vm.$t("common.add")))
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("parametro.add")))])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "form" },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "headline" },
                        [
                          _c("v-icon", [_vm._v("business")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.form.id
                                  ? _vm.$t("parametro.crud.editParametro")
                                  : _vm.$t("parametro.crud.addParametro")
                              ) +
                              "\n            "
                          ),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.$store.commit("closeModal")
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          attrs: { "lazy-validation": "" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.save.apply(null, arguments)
                            }
                          },
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-container",
                                { attrs: { "grid-list-md": "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "nombre",
                                      label: _vm.$t("parametro.crud.name"),
                                      id: "nombre",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      maxlength: "50",
                                      disabled:
                                        _vm.$store.state.user.id_rol == 2
                                    },
                                    model: {
                                      value: _vm.form.nombre,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "nombre", $$v)
                                      },
                                      expression: "form.nombre"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: {
                                      name: "valor",
                                      label: _vm.$t("parametro.crud.value"),
                                      id: "valor",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      maxlength: "50"
                                    },
                                    model: {
                                      value: _vm.form.valor,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "valor", $$v)
                                      },
                                      expression: "form.valor"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "label",
                                      label: _vm.$t("parametro.crud.label"),
                                      id: "label",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      maxlength: "50",
                                      disabled:
                                        _vm.$store.state.user.id_rol == 2
                                    },
                                    model: {
                                      value: _vm.form.label,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "label", $$v)
                                      },
                                      expression: "form.label"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "descripcion",
                                      label: _vm.$t(
                                        "parametro.crud.description"
                                      ),
                                      id: "descripcion",
                                      disabled:
                                        _vm.$store.state.user.id_rol == 2
                                    },
                                    model: {
                                      value: _vm.form.descripcion,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "descripcion", $$v)
                                      },
                                      expression: "form.descripcion"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "small",
                                { staticClass: "error--text text-required" },
                                [_vm._v("* Los campos son obligatorios")]
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.$store.commit("closeModal")
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("cancel")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("common.cancel")) +
                                      "\n              "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    type: "submit",
                                    disabled: !_vm.valid
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("check")
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("common.save")) +
                                      "\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22a8f3bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22a8f3bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/parametro/Index.vue
// module id = null
// module chunks = 